import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { HisCoreModule } from 'hisng';

import { AppComponent } from './app.component';

import { AppRoutesModule } from './app.routes';
import { CommonCoreModule } from './cs/psv/common/common-core.module';

import { providePrimeNG } from 'primeng/config';
import aura from '@primeng/themes/aura';

@NgModule( {
    declarations: [
        AppComponent
    ],
    imports: [
        AppRoutesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule,
        HisCoreModule,
        CommonCoreModule
    ],
    providers: [
        providePrimeNG({
            theme: {
                preset: aura
            }
        }),
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
} )
export class AppModule { }
